export default __webpack_public_path__ + "static/yds-logo-c378802cadf92024b58437f540f13700.jpg";